import React from 'react';

const AboutUS = () => (
    <div id="about" className="about-area area-padding">
        <div className="container">
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="section-headline text-center">
                        <h1 className="h2">Auto Socorro 24h Juniauto</h1>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="well-middle">
                        <div className="single-well">
                            <h4 className="sec-head">Excelência no atendimento</h4>

                            <p>
                                Prestamos socorro veicular 24 horas oferecendo também o serviço de reboque.
                            </p>
                            <p>
                                Possuímos uma ampla parceria para que você nosso cliente possa ser atendido o mais breve possível. Nossos profissionais são bem treinados e estão dispostos a atender da melhor maneira possível para que você, nosso cliente, saia sempre satisfeito.
                            </p>
                            <p>
                                Nossa base principal está localizada estrategicamente próximo do West Shopping no bairro Campo Grande no Rio de Janeiro. Sendo assim estamos totalmente preparados para atender de forma veloz áreas próximas como Bangu, Padre Miguel, Realengo, Santa Cruz, Cosmos e Seropédica. Atualmente, já estamos ampliando nosso serviços para atender outras áreas com uma previsão menor.
                            </p>
                            <p>
                                Se preferir, entre em contato conosco e agende um atendimento no melhor horário para você.
                            </p>
                            <p>
                                Quando precisar, é só nos ligar, será um prazer servir bem.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
);

export default AboutUS;